import ReactModal from 'react-modal';
import H1 from 'components/H1';
import React from 'react';
import { Flex, Box, Button } from 'rebass';
import xhr from 'xhr.js';
import { withToastManager } from 'react-toast-notifications';
import { CreatePersonDataKey } from 'components/PersonDataKey';
import services from 'services/services';
import { FiExternalLink, FiAlertTriangle, FiInfo, FiCalendar } from 'react-icons/fi';
import ParticipantInputElement from 'components/Participant/ParticipantInputElement';
import helpers from 'utils/helpers';
import moment from 'moment-timezone';
import NiceModal from 'components/NiceModal';
import QuickCopy from 'components/QuickCopy';
import { Link } from 'react-router-dom';

class ParticipantSettings extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            participant: this.props.participant,
            showModalAddCustomColumn: false
        };

        this.onFormChange = this.onFormChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.saveParticipantXHR = this.saveParticipantXHR.bind(this);
        this.createParticipantXHR = this.createParticipantXHR.bind(this);
        this.onPersonCustomDataChange = this.onPersonCustomDataChange.bind(this);
        this.handleOpenModalAddCustomColumn = this.handleOpenModalAddCustomColumn.bind(this);
        this.handleCloseModalAddCustomColumn = this.handleCloseModalAddCustomColumn.bind(this);
        this.handleAddColumnSuccess = this.handleAddColumnSuccess.bind(this);
        this.getPersonXHR = this.getPersonXHR.bind(this);
    }

    handleOpenModalAddCustomColumn() {
        this.setState({ showModalAddCustomColumn: true });
    }

    handleCloseModalAddCustomColumn() {
        console.log('CLOSING??/');
        this.setState({ showModalAddCustomColumn: false });
    }

    handleAddColumnSuccess() {
        // e.preventDefault();
        this.getPersonXHR(() => {
            // window.scrollTo(0,document.body.scrollHeight);
            // couldnt get this to focus on the last element, nor scroll tobottom
        });

        const { toastManager } = this.props;
        toastManager.add('Column successfully added.', {
            appearance: 'success',
            autoDismiss: true
        });

        this.handleCloseModalAddCustomColumn();
    }

    getPersonXHR(cb) {
        services.getPerson(this.state.participant.id).then(person => {
            const participant = person;

            this.setState({
                participant
            });

            cb();
        });
    }

    onFormChange(e) {
        if (!e.target.name) {
            return;
        }
        const participant = { ...this.state.participant };
        participant[e.target.name] = e.target.value;
        // console.log(e.target.name);
        this.setState({ participant });

        if (this.props.create) {
            // don't save yet
        } else {
            // detect change, and clear timeout if exists
            if (this.saveDelay) {
                clearTimeout(this.saveDelay);
            }

            // set timer
            this.saveDelay = setTimeout(
                function() {
                    this.saveParticipantXHR(participant);
                }.bind(this),
                500
            );
        }
    }

    onPersonCustomDataChange(e) {
        const customDataKeyId = e.target.name;

        //console.log(e, e.target.type)

        let customDataValue;
        if (e.target.type == 'checkbox') {
            customDataValue = helpers.getCheckboxValuesAsArray(customDataKeyId);
            //console.log(customDataValue);
        } else {
            customDataValue = e.target.value;
        }

        if (!e.target.name) {
            return;
        }
        const participant = { ...this.state.participant };

        if (participant.custom_data_keys && participant.custom_data_keys.length > 0) {
            participant.custom_data_keys.forEach(cdk => {
                if (cdk.id == customDataKeyId) {
                    
                    if (participant.custom_data_values2.hasOwnProperty(customDataKeyId)) {
                        participant.custom_data_values2[customDataKeyId] = customDataValue;
                    } else {
                        participant.custom_data_values2[customDataKeyId] = customDataValue;
                    }
                }
            });
        }

        this.setState({ participant });

        if (this.props.create) {
            // don't save yet
        } else {
            // detect change, and clear timeout if exists
            if (this.saveDelay) {
                clearTimeout(this.saveDelay);
            }

            // set timer for 200ms
            this.saveDelay = setTimeout(
                function() {
                    this.saveParticipantXHR(participant);
                }.bind(this),
                300
            );
        }
    }

    saveParticipantXHR(participant) {
        // console.log('SAVED!!!', participant);

        const { toastManager } = this.props;

        xhr.put(`/people/${participant.id}`, participant, { withCredentials: true })
            .then(response => {
                toastManager.add('Saved', {
                    appearance: 'info',
                    autoDismiss: true
                });

                if (this.props.parentCallback) {
                    this.props.parentCallback(response.data);
                }
            })
            .catch(error => {
                const errorText = services.parseXhrErrors(error);

                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }

    onSubmit(e) {
        e.preventDefault();

        if (this.props.create) {
            this.createParticipantXHR();
        } else {
            this.saveParticipantXHR();
        }
    }

    createParticipantXHR() {
        const { toastManager } = this.props;

        xhr.post(`/people?account_id=${this.props.auth.account.id}`, this.state.participant, {
            withCredentials: true
        })
            .then(res => {
                const p = res.data;
                console.log(res, p.id);

                window.location = `/participants/${p.id}`;
            })
            .catch(error => {
                const errorText = services.parseXhrErrors(error);

                toastManager.add(errorText, {
                    appearance: 'error',
                    autoDismiss: true
                });
            });
    }

    componentWillReceiveProps(nextProps) {
        // You don't have to do this check first, but it can help prevent an unneeded render
        if (nextProps.participant !== this.state.participant) {
            this.setState({ participant: nextProps.participant });
        }
    }

    render() {
        if (!this.state.participant.id && !this.props.create) return null;

        let customParticipantData_sorted = [];
        let customParticipantData = [];

        if (this.state.participant.custom_data_keys && this.state.participant.custom_data_keys.length > 0) {
            this.state.participant.custom_data_keys.forEach(cdk => {
                const foundCDV = this.state.participant.custom_data_values2[cdk.id];

                const inputElement = <ParticipantInputElement cdk={cdk} cdv={{value: foundCDV}} onChange={this.onPersonCustomDataChange} />;

                customParticipantData.push({
                    order: cdk.order,
                    element: <Box key={cdk.id} mb={3}>
                        <Box className="form-label form-row-margin">{cdk.title}</Box>
                        {inputElement}
                    </Box>
                });
            });

            customParticipantData.sort((a, b) => {
                if (a.order < b.order) return -1;
                if (a.order > b.order) return 1;
                return 0;
            });

            customParticipantData.forEach(item => {
                customParticipantData_sorted.push(item.element);
            })
            
        }

        let emailStatusIssues = [];
        if (this.state.participant.email_status && this.state.participant.email_status.length > 0) {
            this.state.participant.email_status.forEach(es => {
                let explainer;
                switch(es.status) {
                    case 'format':
                        explainer = 'Bad e-mail format';
                        break;
                    case 'bounce':
                        explainer = 'Hard bounce';
                        break;
                    case 'spam':
                        explainer = 'Spam complaint';
                }
                emailStatusIssues.push(
                    <Box className='warning-box-small'>
                        <FiInfo className='va-top svg-sw-3px' style={{margin: '4px 8px 0 0'}} />
                        {explainer} for {es.email} when e-mailed on {moment
                        .utc(es.created_at)
                        .format('MMM Do, YYYY [at] h:mma')}
                    </Box>
                )
            })
        }

        let panelistEligibilityIssues = helpers.renderPanelistEligibility(this.state.participant);

        return (
            <Box>
                {panelistEligibilityIssues && <Box mb={'22px'}>
                    <Box className="form-label">
                        Fatigue Status{' '}
                        <a className="bold" href={`/settings#panelist-fatigue`} target="_blank">
                            <FiExternalLink />
                        </a>
                    </Box>
                    {panelistEligibilityIssues}
                </Box>}
                {emailStatusIssues.length > 0 && <Box mb={'22px'}>
                    <Box className="form-label">Email Issues</Box>
                    {emailStatusIssues}
                </Box>}
                <Box mb={2}>
                    <Box className="form-label">Panelist UUID</Box>
                    <Flex className="text-primary">
                        {this.state.participant.uuid}
                        <Box sx={{margin: '0 0 0 8px'}}><QuickCopy value={this.state.participant.uuid} /></Box>
                    </Flex>
                </Box>
                <form onSubmit={this.onSubmit} className="new-input-wrapper">
                    {customParticipantData_sorted}

                    <Button type="button" variant="link" onClick={this.handleOpenModalAddCustomColumn} mb={3}>
                        + Add Panelist Property
                    </Button>

                    {this.props.create ? (
                        <Button mt={3} type="submit" onClick={this.onSubmit}>
                            Create
                        </Button>
                    ) : (
                        ''
                    )}
                </form>

                {!this.props.create && (
                    <NiceModal
                        isOpen={this.state.showModalAddCustomColumn}
                        shouldCloseOnOverlayClick
                        onRequestClose={this.handleCloseModalAddCustomColumn}
                        title={`Add a panelist property`}
                    >
                        <CreatePersonDataKey
                            onSuccess={this.handleAddColumnSuccess}
                            onClose={this.handleCloseModalAddCustomColumn}
                        />
                    </NiceModal>
                )}
            </Box>
        );
    }
}

export default withToastManager(ParticipantSettings);
